export const PAYOUT_TRANSACTION_TYPE = {
    PAYMENTS: 'payments',
    DEBIT: 'debit',
    REFUNDS: 'refunds',
};
